<template>
  <div class="text-left">
    {{
      getPersonNameAndGender({
        personId: mainMandateData.building_owner_id,
      })
    }}
    <br />
    <b-badge variant="warning">
      {{
        getUsedMandateTantiemesByVotingCategory(
          mainMandateData.id,
          currentResolution.voting_category_id
        )
      }}
    </b-badge>
  </div>
</template>

<script>
export default {
  props: {
    // for votings table
    currentResolution: {
      type: Object,
      default: () => {
        return {};
      },
    },
    mainMandate: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      mainMandateData: {},
    };
  },
  watch: {
    mainMandate(newVal, oldVal) {
      if (!this.$_.isEqual(newVal, oldVal)) {
        this.mainMandateData = newVal;
      }
    },
  },
  created() {
    this.mainMandateData = this.mainMandate;
  },
};
</script>
